"use client"
import Link from "next/link";

const CallUs = () => {
    const handleClick = () => {
        gtag('event', 'ivr_select');
    }

    return (
        <Link
            href="tel:18002120299"
            aria-label="Email ORNAZ"
            variant="outline"
            className="
                h-[45px] min-w-[200px] px-5 text-center text-xs lg:text-sm text-black
                flex items-center justify-center select-none bg-[#73cbcc] hover:drop-shadow
                hover:bg-[#56f0f1] rounded-sm border-none font-semibold drop-shadow	
            "
            onClick={handleClick}
        >
            18002120299
        </Link>
    )
}

export default CallUs